/**
 * Reusable Chat Badge Component
 * Shows notification count for new messages
 * Used in TabBar, Settings, and other places
 */

import React from 'react';
import { cn } from '@/lib/utils';

interface ChatBadgeProps {
  count: number;
  size?: 'sm' | 'md';
  className?: string;
}

export const ChatBadge: React.FC<ChatBadgeProps> = ({
  count,
  size = 'md',
  className,
}) => {
  if (!count || count <= 0) return null;

  const displayCount = count > 99 ? '99+' : count;
  
  const sizeClasses = size === 'sm' 
    ? 'min-w-[16px] h-[16px] text-[10px] px-0.5'
    : 'min-w-[18px] h-[18px] text-[11px] px-1';

  return (
    <span
      className={cn(
        'rounded-full bg-bg-accent-pink flex items-center justify-center text-text-primary font-bold',
        sizeClasses,
        className
      )}
    >
      {displayCount}
    </span>
  );
};

export default ChatBadge;
